// src/components/Header.js

import React, {
    useContext, useState, useEffect
} from 'react';
import '../../globals.css';
import './styles.css';
import Profile from './Profile';
import {
    Context
} from 'shared/context/GlobalState';
import coolriots from 'assets/coolriots.png';
import {
    Link
} from 'react-router-dom';
import {
    GiHamburgerMenu
} from 'react-icons/gi';
import DashboardSubHeader from 'shared/components/DashboardSubHeader';
import OrgDropdown from 'shared/components/OrgDropdown';
import StudioOrgPills from 'shared/components/StudioOrgPills';
import {
    useLocation, useNavigate, useParams
} from 'react-router-dom';
import StudioProductTabs from 'shared/components/StudioProductTabs';
import {
    ThemeToggle
} from 'shared/components/theme/ThemeToggle';
import {
    authService
} from 'shared/api';

export default function Header() {
    const MAXIMUM_WIDTH = 900;

    const {
        isAuth
    } = useContext(Context);
    const [showMenu, setShowMenu] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const navigate = useNavigate();
    const {
        pathname
    } = useLocation();
    const {
        oragID
    } = useParams();

    const onAppStudio = pathname.includes('/3dapp-studio');
    const showStudioTabs = isAuth && oragID
        && (onAppStudio || pathname.includes('/de-studio'));
    // 3D App Studio uses the same org + sub-org pills as DE Studio. Other
    // routes keep the platform OrgDropdown.
    const orgPicker = isAuth && (onAppStudio ? <StudioOrgPills /> : <OrgDropdown />);

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Refactor: this function to use the GlobalState context
    const handleLogOut = () => {
        authService.logout()
            .then(() => {

                //   localStorage.removeItem('selectedSubOrg');

                navigate('/auth/login');
            }).catch(() => {

            });
    };

    return (
        <header className={`header-container border-b${showStudioTabs ? ' header-container--studio' : ''}`}>
            <svg width="0" height="0" className="absolute pointer-events-none">
                <filter id="coolriots-dark-filter" colorInterpolationFilters="sRGB">
                    <feColorMatrix type="matrix" values="
                        0 0 0 0 1
                        -1 0 0 0 1
                        -1 0 0 0 1
                        0 0 0 1 0
                    " />
                </filter>
            </svg>
            <div className="header-left flex gap-3 items-center">
                <div onClick={() => (window.location = '/organizations')} className="header-icon-container">
                    <img src={coolriots} alt="coolriots" className="dark:[filter:url(#coolriots-dark-filter)] transition-all" />
                </div>
                <div className='hidden md:block'>
                    {orgPicker}
                </div>
            </div>

            {showStudioTabs && (
                <div className="header-center studio-tabs-desktop">
                    <StudioProductTabs />
                </div>
            )}

            {!window.location.pathname.includes('secure') && (
                <div className={`nav-container ${showMenu ? 'show-menu' : ''}`}>

                    <div className='md:hidden block'>
                        {orgPicker}
                    </div>
                    {showStudioTabs && (
                        <div className="studio-tabs-mobile">
                            <StudioProductTabs />
                        </div>
                    )}
                    {isAuth && <DashboardSubHeader />}

                    {windowWidth < MAXIMUM_WIDTH && isAuth ? (
                        <>
                            <ThemeToggle />
                            <span onClick={handleLogOut}>Logout</span>
                        </>
                    ) : (
                        isAuth ? (
                            <div className="flex items-center gap-2">
                                <ThemeToggle />
                                <Profile />
                            </div>
                        ) : (
                            <div className="flex items-center gap-2">
                                <ThemeToggle />
                                <span><Link to="/auth/login">Login</Link></span>
                            </div>
                        )
                    )}
                </div>
            )}

            <div className="burger-icon" onClick={toggleMenu}>
                <GiHamburgerMenu />
            </div>
        </header>
    );
}